import { render } from "./Tablets.vue?vue&type=template&id=30f79bbb&scoped=true"
import script from "./Tablets.vue?vue&type=script&lang=js"
export * from "./Tablets.vue?vue&type=script&lang=js"

import "./Tablets.vue?vue&type=style&index=0&id=30f79bbb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f79bbb"]])

export default __exports__